import setReduxAction from 'modules/redux/actions/set'
import createInstanceCreateUtil from 'modules/redux/actions/create/create-instance'
import createInstancesCreateReduxUtil from 'modules/redux/actions/create/create-instances'

function createReduxAction (action) {
  return (dispatch, getState) => {
    const stateWrapper = {
      state: { ...getState() }
    }

    let data
    if (Array.isArray(action.payload.data)) {
      data = createInstancesCreateReduxUtil(stateWrapper, action.payload)
    } else {
      data = createInstanceCreateUtil(stateWrapper, action.payload)
    }

    dispatch(
      setReduxAction({
        type: action.type,
        payload: {
          path: '',
          value: stateWrapper.state
        }
      })
    )

    return data
  }
}

export default createReduxAction
